module.exports = __webpack_public_path__ + "img/kh.3a7a7d57.svg";